import React from 'react';
import SuIdmanSarayiFilms from './SuIdmanSarayiFilms';
// import BuzovnaFilms from './BuzovnaFilms';
// import { useTranslation } from 'react-i18next';

const CentersSelect = () => {

  // const [activeTab, setActiveTab] = useState(1);
  // const { t } = useTranslation();
  


  return (
    <div className="">
      <div className="flex justify-between gap-[20px] container max-[400px]:flex-col">
        <button
          className="p-[10px_15px] rounded-[12px] font-semibold w-full bg-purple text-white"
        >
          Buzovna Dənizkənarı
        </button>
        {/* Buzovna Parking — временно скрыт, код сохранён для возможного возврата
        <button
          className={`p-[10px_15px] rounded-[12px] font-semibold w-full ${
            activeTab === 2 ? 'bg-blue text-white' : 'bg-main text-white border border-blue'
          }`}
          onClick={() => setActiveTab(2)}
        >
          Buzovna Parking
        </button>
        */}
      </div>
      <div className='my-5'>
        <SuIdmanSarayiFilms />
        {/* {activeTab === 2 && <BuzovnaFilms />} */}
      </div>
    </div>
  );
};

export default CentersSelect;
